/**
 * Utility functions for handling dropdown values
 */

/**
 * Serializes a value or array of values to a string representation
 */
export function serializeValue<TValue>(value: TValue | Array<TValue>, isMultiple: boolean): string {
  if (isMultiple) {
    if (Array.isArray(value)) {
      return value.map((v) => String(v)).join(',');
    }
    return '';
  }
  return value !== undefined && value !== null ? String(value) : '';
}

/**
 * Deserializes a string representation back to a value or array of values
 */
export function deserializeValue<TValue>(serialized: string, isMultiple: boolean): TValue | Array<TValue> {
  if (!serialized) {
    return isMultiple ? ([] as unknown as Array<TValue>) : ('' as unknown as TValue);
  }

  if (isMultiple) {
    return serialized.split(',').filter(Boolean) as unknown as Array<TValue>;
  }

  return serialized as unknown as TValue;
}

/**
 * Gets the selected options based on the current value
 */
export function getSelectedOptions<TValue>(
  options: Array<{ value: TValue; label: string; testId?: string; disabled?: boolean }>,
  value: TValue | Array<TValue>,
  isMultiple: boolean,
) {
  if (isMultiple) {
    return Array.isArray(value) ? options.filter((option) => value.includes(option.value)) : [];
  }

  const selectedOption = options.find((option) => option.value === value);
  return selectedOption ? [selectedOption] : [];
}

/**
 * Gets the controlled value for the dropdown
 */
export function getControlledValue<TValue>(value: TValue | Array<TValue>, isMultiple: boolean): TValue | Array<TValue> {
  return isMultiple ? (Array.isArray(value) ? value : []) : value;
}
